import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { ExerciseContext } from "../context/ExerciseContext";
import "../styles/ExerciseSelector.css";

// Importy pro grafy (Recharts)
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';

// Seznam cviků s dvěma verzemi videa
const exercises = [

{ name: "Jack Burpee", cardio: 10, strength: 8, image: "/images/exercises_lowres/Jack-Burpee-360.mp4", videoTimer: "/images/exercises_hires/Jack-Burpee-720.mp4", bodyPart: "Full body", equipment: "Bodyweight", exerciseType: "Cardio" },
{ name: "Close Grip Push up", cardio: 5, strength: 10, image: "/images/exercises_lowres/Close-Grip-Push-up_Upper-Arms-360.mp4", videoTimer: "/images/exercises_hires/Close-Grip-Push-up_Upper-Arms-720.mp4", bodyPart: "Upper body", equipment: "Bodyweight", exerciseType: "Strength" },
{ name: "Wide Hand Push up", cardio: 4, strength: 8, image: "/images/exercises_lowres/Wide-Hand-Push-up-360.mp4", videoTimer: "/images/exercises_hires/Wide-Hand-Push-up-720.mp4", bodyPart: "Upper body", equipment: "Bodyweight", exerciseType: "Strength" },
{ name: "Jumping Jack", cardio: 7, strength: 1, image: "/images/exercises_lowres/Jumping-Jack-360.mp4", videoTimer: "/images/exercises_hires/Jumping-Jack-720.mp4", bodyPart: "Full body", equipment: "Bodyweight", exerciseType: "Cardio" },
{ name: "Wide Jump Squat", cardio: 7, strength: 7, image: "/images/exercises_lowres/Wide-Stance-Jump-360.mp4", videoTimer: "/images/exercises_hires/Wide-Stance-Jump-720.mp4", bodyPart: "Lower body", equipment: "Bodyweight", exerciseType: "Strength" },
{ name: "High Knee Sprints", cardio: 8, strength: 3, image: "/images/exercises_lowres/High-Knee-Sprints-360.mp4", videoTimer: "/images/exercises_hires/High-Knee-Sprints-720.mp4", bodyPart: "Full body", equipment: "Bodyweight", exerciseType: "Cardio" },
{ name: "Cardio Lunge", cardio: 8, strength: 6, image: "/images/exercises_lowres/Cardio-Lunge-360.mp4", videoTimer: "/images/exercises_hires/Cardio-Lunge-720.mp4", bodyPart: "Full body", equipment: "Bodyweight", exerciseType: "Cardio" },
{ name: "Sit up", cardio: 3, strength: 7, image: "/images/exercises_lowres/Sit-up-360.mp4", videoTimer: "/images/exercises_hires/Sit-up-720.mp4", bodyPart: "Core", equipment: "Bodyweight", exerciseType: "Strength" },
{ name: "Air Squat", cardio: 6, strength: 7, image: "/images/exercises_lowres/Air-Squat-360.mp4", videoTimer: "/images/exercises_hires/Air-Squat-720.mp4", bodyPart: "Lower body", equipment: "Bodyweight", exerciseType: "Strength" },
{ name: "Alternate Punching", cardio: 4, strength: 2, image: "/images/exercises_lowres/Alternate-Punching-360.mp4", videoTimer: "/images/exercises_hires/Alternate-Punching-720.mp4", bodyPart: "Upper body", equipment: "Bodyweight", exerciseType: "Cardio" },
{ name: "Jack Split Crunches", cardio: 5, strength: 9, image: "/images/exercises_lowres/Jack-Split-Crunches-360.mp4", videoTimer: "/images/exercises_hires/Jack-Split-Crunches-720.mp4", bodyPart: "Core", equipment: "Bodyweight", exerciseType: "Strength" },
{ name: "High Knee Walk", cardio: 6, strength: 2, image: "/images/exercises_lowres/Walk-360.mp4", videoTimer: "/images/exercises_hires/Walk-720.mp4", bodyPart: "Full body", equipment: "Bodyweight", exerciseType: "Cardio" },
{ name: "90 Degree Heel Touch", cardio: 2, strength: 7, image: "/images/exercises_lowres/90-Degree-Heel-Touch-360.mp4", videoTimer: "/images/exercises_hires/90-Degree-Heel-Touch-720.mp4", bodyPart: "Core", equipment: "Bodyweight", exerciseType: "Strength" },
{ name: "Butt Kicks", cardio: 5, strength: 1, image: "/images/exercises_lowres/Butt-Kicks-360.mp4", videoTimer: "/images/exercises_hires/Butt-Kicks-720.mp4", bodyPart: "Lower body", equipment: "Bodyweight", exerciseType: "Cardio" },
{ name: "Alternate Heel Touchers", cardio: 3, strength: 7, image: "/images/exercises_lowres/Alternate-Heel-Touchers-360.mp4", videoTimer: "/images/exercises_hires/Alternate-Heel-Touchers-720.mp4", bodyPart: "Core", equipment: "Bodyweight", exerciseType: "Strength" },
{ name: "Long Distance Lunge (Low Lunge)", cardio: 4, strength: 6, image: "/images/exercises_lowres/Long-Distance-Lunge-360.mp4", videoTimer: "/images/exercises_hires/Long-Distance-Lunge-720.mp4", bodyPart: "Lower body", equipment: "Bodyweight", exerciseType: "Strength" },
{ name: "Superman", cardio: 1, strength: 3, image: "/images/exercises_lowres/Superman-360.mp4", videoTimer: "/images/exercises_hires/Superman-720.mp4", bodyPart: "Full body", equipment: "Bodyweight", exerciseType: "Strength" },
{ name: "Mountain Climber", cardio: 8, strength: 6, image: "/images/exercises_lowres/Mountain-Climber-360.mp4", videoTimer: "/images/exercises_hires/Mountain-Climber-720.mp4", bodyPart: "Full body", equipment: "Bodyweight", exerciseType: "Cardio" },
{ name: "Split Squats", cardio: 2, strength: 5, image: "/images/exercises_lowres/Split-Squats-360.mp4", videoTimer: "/images/exercises_hires/Split-Squats-720.mp4", bodyPart: "Lower body", equipment: "Bodyweight", exerciseType: "Strength" },
{ name: "Skater Hops", cardio: 8, strength: 5, image: "/images/exercises_lowres/Skater-Hops-360.mp4", videoTimer: "/images/exercises_hires/Skater-Hops-720.mp4", bodyPart: "Lower body", equipment: "Bodyweight", exerciseType: "Cardio" },
{ name: "Push up (on knees)", cardio: 3, strength: 6, image: "/images/exercises_lowres/Push-up-on-knees-360.mp4", videoTimer: "/images/exercises_hires/Push-up-on-knees-720.mp4", bodyPart: "Upper body", equipment: "Bodyweight", exerciseType: "Strength" },
{ name: "Bicycle Crunch", cardio: 7, strength: 5, image: "/images/exercises_lowres/Bicycle-Crunch-360.mp4", videoTimer: "/images/exercises_hires/Bicycle-Crunch-720.mp4", bodyPart: "Core", equipment: "Bodyweight", exerciseType: "Strength" },
{ name: "Cross Standing Crunch", cardio: 4, strength: 5, image: "/images/exercises_lowres/Cross-Standing-Crunch-360.mp4", videoTimer: "/images/exercises_hires/Cross-Standing-Crunch-720.mp4", bodyPart: "Core", equipment: "Bodyweight", exerciseType: "Strength" },
{ name: "Bear Crawl (low hip)", cardio: 4, strength: 7, image: "/images/exercises_lowres/Bear-Crawl-low-hip-360.mp4", videoTimer: "/images/exercises_hires/Bear-Crawl-low-hip-720.mp4", bodyPart: "Full body", equipment: "Bodyweight", exerciseType: "Strength" },
{ name: "Bird Dog Plank", cardio: 2, strength: 6, image: "/images/exercises_lowres/Bird-Dog-Plank-360.mp4", videoTimer: "/images/exercises_hires/Bird-Dog-Plank-720.mp4", bodyPart: "Full body", equipment: "Bodyweight", exerciseType: "Strength" },
{ name: "Isometric Hold Push up", cardio: 1, strength: 7, image: "/images/exercises_lowres/Isometric-Hold-Push-up-360.mp4", videoTimer: "/images/exercises_hires/Isometric-Hold-Push-up-720.mp4", bodyPart: "Upper body", equipment: "Bodyweight", exerciseType: "Strength" },
{ name: "Air-bike", cardio: 4, strength: 7, image: "/images/exercises_lowres/Air-bike-360.mp4", videoTimer: "/images/exercises_hires/Air-bike-720.mp4", bodyPart: "Core", equipment: "Bodyweight", exerciseType: "Strength" },
{ name: "Air Bike v2", cardio: 4, strength: 8, image: "/images/exercises_lowres/Air-Bike-v2-360.mp4", videoTimer: "/images/exercises_hires/Air-Bike-v2-720.mp4", bodyPart: "Core", equipment: "Bodyweight", exerciseType: "Strength" },
{ name: "Finger Push up", cardio: 4, strength: 10, image: "/images/exercises_lowres/Finger-Push-up-360.mp4", videoTimer: "/images/exercises_hires/Finger-Push-up-720.mp4", bodyPart: "Upper body", equipment: "Bodyweight", exerciseType: "Strength" },
{ name: "Knuckle Push Up", cardio: 4, strength: 9, image: "/images/exercises_lowres/Knuckle-Push-Up-360.mp4", videoTimer: "/images/exercises_hires/Knuckle-Push-Up-720.mp4", bodyPart: "Upper body", equipment: "Bodyweight", exerciseType: "Strength" },
{ name: "Clap Push Up", cardio: 5, strength: 10, image: "/images/exercises_lowres/Clap-Push-Up-360.mp4", videoTimer: "/images/exercises_hires/Clap-Push-Up-720.mp4", bodyPart: "Upper body", equipment: "Bodyweight", exerciseType: "Cardio" },
{ name: "Jump Rope", cardio: 3, strength: 4, image: "/images/exercises_lowres/Jump-Rope-360.mp4", videoTimer: "/images/exercises_hires/Jump-Rope-720.mp4", bodyPart: "Lower body", equipment: "Jump Rope", exerciseType: "Cardio" },
{ name: "Jump Box", cardio: 3, strength: 4, image: "/images/exercises_lowres/Jump-Box-360.mp4", videoTimer: "/images/exercises_hires/Jump-Box-720.mp4", bodyPart: "Full body", equipment: "Plyo box", exerciseType: "Strength" },
{ name: "Hook Kick Kickboxing (with boxing bag)", cardio: 9, strength: 8, image: "/images/exercises_lowres/Hook-Kick-Kickboxing-360.mp4", videoTimer: "/images/exercises_hires/Hook-Kick-Kickboxing-720.mp4", bodyPart: "Full body", equipment: "Boxing bag", exerciseType: "Cardio" },
{ name: "Front Kick Kickboxing (with boxing bag)", cardio: 5, strength: 4, image: "/images/exercises_lowres/Front-Kick-Kickboxing-360.mp4", videoTimer: "/images/exercises_hires/Front-Kick-Kickboxing-720.mp4", bodyPart: "Lower body", equipment: "Boxing bag", exerciseType: "Cardio" },

];

const ExerciseSelector = () => {
  const { selectedExercises, setSelectedExercises } = useContext(ExerciseContext);
  const navigate = useNavigate();

  // Aktualizace vybraného cviku
  const handleChange = (index, selectedOption) => {
    const updatedExercises = [...selectedExercises];
    updatedExercises[index] = selectedOption;
    setSelectedExercises(updatedExercises);
  };

  // Průměrné hodnoty pro grafy
  const averageCardio = selectedExercises.filter(Boolean).reduce((acc, exercise) => acc + exercise.cardio, 0) / selectedExercises.filter(Boolean).length;
  const averageStrength = selectedExercises.filter(Boolean).reduce((acc, exercise) => acc + exercise.strength, 0) / selectedExercises.filter(Boolean).length;

  const handleContinue = () => navigate("/ad"); // tlačítko pro pokračování

  // Data pro LineChart
  const graphData = selectedExercises.map(exercise => ({
    name: exercise ? exercise.name : '',
    strength: exercise ? exercise.strength : 0,
    cardio: exercise ? exercise.cardio : 0,
  }));

  const renderGraph = graphData.length > 0;

  // Data pro PieChart
  const pieChartDataCardio = [
    { name: 'Kardio', value: averageCardio },
    { name: 'Ostatní', value: 10 - averageCardio },
  ];

  const pieChartDataStrength = [
    { name: 'Síla', value: averageStrength },
    { name: 'Ostatní', value: 10 - averageStrength },
  ];

  return (
    <div className="exercise-selector-container">
      <img src="/images/background.jpg" alt="background" className="bg-video" />
      <div className="overlay"></div>

      <div className="logo-container">
        <a href="https://www.tabataworkout.online">
          <img src="/images/logo.png" alt="Logo" className="logo" />
        </a>
      </div>

      <div>
        <h4>Choose 8 Exercises</h4>
        <div className="selectors">
          {Array.from({ length: 8 }).map((_, index) => (
            <div key={index} className="selector">
              {/* React Select pro výběr cviku */}
              <Select
                options={exercises.map(ex => ({ value: ex.name, label: ex.name, ...ex }))}
                onChange={(selectedOption) => handleChange(index, selectedOption)}
                placeholder={`Exercise  ${index + 1}`}
                isSearchable
                filterOption={(option, rawInput) => {
                  const input = rawInput.toLowerCase();
                  return (
                    option.data.name.toLowerCase().includes(input) ||
                    option.data.bodyPart.toLowerCase().includes(input) ||
                    option.data.equipment.toLowerCase().includes(input) ||
                    option.data.exerciseType.toLowerCase().includes(input)
                  );
                }}
                formatOptionLabel={(option) => (
                  <div>
                    <strong>{option.label}</strong>
                    <div style={{ fontSize: "0.8em", color: "#555" }}>
                      Cardio: {option.cardio} | Strength: {option.strength} | Body part: {option.bodyPart} | Equipment: {option.equipment} | Type: {option.exerciseType}
                    </div>
                  </div>
                )}
                menuPortalTarget={document.body}
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              />

              {/* Zobrazení videa miniatura */}
              {selectedExercises[index] && (
                <div>
                  <video
                    src={selectedExercises[index].image} // menší verze pro výběr
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="exercise-image"
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {renderGraph && (
        <div style={{ marginTop: "10px" }}>
          <h4>Strength & Cardio Chart (based on selected exercises)</h4>
          <ResponsiveContainer width="100%" height={200}>
            <LineChart data={graphData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" tick={{ fill: "1c192c" }} />
              <YAxis tick={{ fill: "1c192c" }} />
              <Tooltip />
              <Legend />
              <Line type="monotone" dataKey="strength" stroke="#E51937" />
              <Line type="monotone" dataKey="cardio" stroke="#1c192c" />
            </LineChart>
          </ResponsiveContainer>

          {/* PieCharts pro průměrné hodnoty */}
          <div style={{ display: 'flex', justifyContent: 'center', gap: '30px', marginTop: "5px" }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <h4>Average Cardio</h4>
              <PieChart width={300} height={100}>
                <Pie data={pieChartDataCardio} dataKey="value" cx="50%" cy="50%" innerRadius={30} outerRadius={50}>
                  {pieChartDataCardio.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.name === 'Kardio' ? '#1c192c' : '#dcdcdc'} />
                  ))}
                </Pie>
              </PieChart>
              <p>{averageCardio.toFixed(1)} / 10</p>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <h4>Average Strength</h4>
              <PieChart width={300} height={100}>
                <Pie data={pieChartDataStrength} dataKey="value" cx="50%" cy="50%" innerRadius={30} outerRadius={50}>
                  {pieChartDataStrength.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.name === 'Síla' ? '#E51937' : '#dcdcdc'} />
                  ))}
                </Pie>
              </PieChart>
              <p>{averageStrength.toFixed(1)} / 10</p>
            </div>

            <div className="start-button-container">
              <button onClick={handleContinue}>Start Workout</button>
            </div>
          </div>

<div className="app-version">
  © 2025 Tabataworkout.online. All rights reserved.
  {" | "}
  <a href="/about" style={{ color: "#1c192c" }}>About</a>
  {" | "}
  <a href="https://www.tabataworkout.online" target="_blank" rel="noopener noreferrer" style={{ color: "#1c192c" }}>
    Home
  </a>
</div>
        </div>
      )}
      
    </div>
  );
};

export default ExerciseSelector;
